import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpHeaders
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError, retry } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';
import { CommonService } from '../services/common.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService {

  constructor(
    private _loading: LoadingService,
    private commonservice: CommonService,
    private toast:ToastrService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      const mongoExportApi =environment.orderAPIURL;
    if (req.url.includes(mongoExportApi)) {
        const clone = req.clone({
          headers: new HttpHeaders({
            'Accept': 'application/json'
          })
        });
        return next.handle(clone);
      }
    let userDetails: any = JSON.parse(localStorage.getItem('userDetails'));
    if(userDetails){
      var id = userDetails.userId;
      var token = 'Bearer ' + localStorage.getItem('token');
    } else {
      id = 'RNpS7aki0COQm6WEg9WE8VWiopu9rF5oQank2AdWyM3UKr62WUu9l1R1BfaO9';
      token = 'Bearer aqSkKT6qguVyANMPtR6qqWaiCLUTRNpS7aki0COQm6WEg9WE8VWiopu9rF5oQank2AdWyM3UKr62WUu9l1R1BfaO9CzM16Vi89ecAX6ADPfhGBzpAEXze1do0SqtMkdQ5oGqFqtXphoc4DZL4hb6wRdg09RWzEJcnYJLtvska9HfvQiywtu1LZvDt1AD104ypzLaIRV6dGtKWHrhYgxVn7D3Q9mkTS3oejbVX8z81RwN3Ely6g59t5RRU88BVJiv'
    }
    const clone = req.clone({
      headers: new HttpHeaders({
      'Accept': 'application/json',
      'requestId': id,
      'Authorization':token,
      'isAdmin': 'true'
    })
  });
  console.log('Request Headers:', clone.headers);
  this._loading.setLoading(true,req.url);
    return next.handle(clone).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
                this._loading.setLoading(false, req.url);
        }
        return event;
      }),
      retry(1),
      catchError((error: HttpErrorResponse) => {
        this._loading.setLoading(false, req.url);
        if(error?.error?.message == 'jwt expired' || error?.error?.message == 'jwt malformed'){
          this.toast.warning('Session Expired!!');
          this.commonservice.logout();
        }
        return throwError(error);
      })
    );
  }
}
